<div class="w-100 bg-white p-md-5 pt-md-0" style="padding: 1rem;">
    <div class="slider d-flex align-items-start flex-wrap">
        <!-- Loan Amount Slider -->
        <div class="flex-grow-1 mt-5">
            <div>
                <div class="titles d-flex w-100 align-items-center justify-content-between">
                    <h5>Loan Amount</h5>
                    <h5 class="loan-amount-wrapper">
                        <span class="currency-symbol">₹</span>
                        <input type="number" class="loan-input" [(ngModel)]="sliderLoanAmount" [min]="minAmount"
                            [max]="inPrincipleAmount" (input)="updateInputWidth($event)" [value]="sliderLoanAmount"
                            [attr.min]="minAmount" [attr.max]="inPrincipleAmount" #loanInput />
                        <!-- Hidden mirror element to calculate width -->
                        <span class="input-mirror" #inputMirror>{{ sliderLoanAmount || minAmount }}</span>
                    </h5>
                </div>
                <div class="range">
                    <div class="field w-100">
                        <div class="d-flex w-100 gap-2 align-items-center justify-content-between">
                            <div class="value left" (click)="handleDecrese('loan_amount')">
                                <p>-</p>
                            </div>
                            <input class="w-100" type="range" [value]="sliderLoanAmount" [min]="minAmount"
                                [max]="getMaxAmount()" (input)="handleSliderChange($event, 'loan_amount')"
                                [disabled]="isSliderDisabled" />
                            <div class="value right" (click)="handleIncrease('loan_amount')">
                                <p>+</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Interest Slider -->
            <div class="mt-3 mb-3">
                <div class="titles d-flex w-100 align-items-center justify-content-between">
                    <h5>Interest</h5>
                    <h5>{{ intrestPercent }}%</h5>
                </div>
                <div class="range">
                    <div class="field w-100">
                        <div class="d-flex w-100 gap-2 align-items-center justify-content-between">
                            <div class="gray left">
                                <p>-</p>
                            </div>
                            <input class="w-100" type="range" [value]="intrestPercent" min="1" max="100" disabled />
                            <div class="gray right">
                                <p>+</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Tenure Slider -->
            <div>
                <div class="titles d-flex w-100 align-items-center justify-content-between">
                    <h5>Tenure (Months)</h5>
                    <h5>{{ tenor }}</h5>
                </div>
                <div class="range">
                    <div class="field w-100">
                        <div class="d-flex w-100 gap-2 align-items-center justify-content-between">
                            <div class="value left" (click)="handleDecrese('tenor')">
                                <p>-</p>
                            </div>
                            <!-- <input class="w-100" type="range" [value]="tenor" [min]="tenureList[0]"
                                [max]="tenureList[tenureList.length - 1]" [step]="1"
                                (input)="handleSliderChange($event, 'tenor')"  /> -->
                            <app-stop-point-slider class="w-100" [stopPoints]="tenureList" [(selectedValue)]="tenor"
                                (valueChange)="handleSliderChange($event, 'tenor')"
                                [isSliderDisabled]="isSliderDisabled">
                            </app-stop-point-slider>
                            <div class="value right" (click)="handleIncrease('tenor')">
                                <p>+</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Loan & Charges Summary Section -->
        <div class="cards-section">
            <h2>Loan & Charges Summary</h2>
            <div class="card">
                <div class="card-body">
                    <h1>{{ sliderLoanAmount | currency: 'INR':'symbol':'1.0-0' }}</h1>
                    <p>Loan Amount</p>
                </div>
            </div>
            <div class="card mt-2 mb-2">
                <div class="card-body">
                    <h1>{{ intrestAmount | currency: 'INR':'symbol':'1.0-0' }}</h1>
                    <p>Total Interest Payable</p>
                </div>
            </div>
            <div class="card mt-2 mb-2">
                <div class="card-body">
                    <span class="d-flex align-items-center justify-content-between flex-row-reverse text-xs">
                        ({{ suggestedPlan.processing_fee | currency: 'INR':'symbol':'1.0-0' }} + {{ suggestedPlan.gst |
                        currency: 'INR':'symbol':'1.0-0' }})
                        <h1>
                            {{ suggestedPlan.gst + suggestedPlan.processing_fee | currency: 'INR':'symbol':'1.0-0' }}
                        </h1>
                    </span>
                    <p>Processing Fee + GST</p>
                </div>
            </div>
            <div class="card">
                <div class="card-body">
                    <h1>{{ tottalPayableAmount | currency: 'INR':'symbol':'1.0-0' }}</h1>
                    <p>Total Payment</p>
                </div>
            </div>
            <div class="row justify-content-center text-center buttonDiv mt-2 mb-2">
                <div class="col-12">
                    <button class="btn btn-warning" (click)="handleCalculateEMIPlan()">Proceed</button>
                </div>
            </div>
        </div>
    </div>
</div>

<ngx-spinner type="ball-spin-clockwise" size="medium"></ngx-spinner>